import { connect } from 'react-redux';
import { initialFetch } from './redux/actions';
import { getCanUserHaveWatchedGroups, getMainNavItems, getIsNetworkBarInitialized, getCanUserHaveRecommendedGroups } from './redux/selectors';
import { getCanUserSeeWatch, getIsMobile } from '../publicSession/selectors';
const mapStateToProps = (state)=>({
        showWatchedGroupsEmptyState: !getCanUserHaveWatchedGroups(state),
        showRecommendedGroups: getCanUserHaveRecommendedGroups(state),
        mainNavItems: getMainNavItems(state),
        isInitialized: getIsNetworkBarInitialized(state),
        canSeeOldWatch: getCanUserSeeWatch(state),
        canSeeShop: getIsMobile(state)
    });
const mapDispatchToProps = {
    initialFetch
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=NetworkBar.container.js.map